import { render, staticRenderFns } from "./lastMinute.vue?vue&type=template&id=d1095292&scoped=true&"
import script from "./lastMinute.vue?vue&type=script&lang=js&"
export * from "./lastMinute.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1095292",
  null
  
)

export default component.exports